var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    y: 0,
    width: 30,
    height: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17,7.3c.2.7.2,1.4.4,2s.5,1,.7,1.6-.1.9.4,1.6,1.3,1.2,1.7,2.4c.9,2.7-1.5,4.1-3.1,5.7s-1,1.8-2.4,1.9-2.2,0-2.5,0c-.7-.2-.4-1.1-.8-1.6s-.9-.4-1.3-.7,0-1.5-1.3-1.6-1.9.5-2.9,1.1-1.4,0-2.3.2-2.1,1.6-2.3.3.6-3.1.8-4.7-.2-1.6.6-2.4,1.5-.4,2.3-.7,1.8-1,2.3-1.7.8-1.8,1.7-1.7.6.3.8.3c.6,0,1.4-1.6,2.2-1.7s2,0,1.9,1-1.2.9,0,1.9,1.4,1,1.8.2.4-2.2.9-3.1.1-.4.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,7.4c-1.3.2-1.7-.6-2.4-1.5-1,1.3-1.6.3-2.4.2s-.8.3-1.2.2c0-.4.3-.6.3-.9.2-1.2-2.2-1.3-2.7-1.8s-.5-1.2-.2-1.6c.4-.5.7.5.9.7.8.9,1.4-.1,2.1-.3,1.4-.3,3.3.6,3.9,1.8s.3,1.1.7,1.6,1,.8.9,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2,24.7c0,0,.3-.4.5-.6.6-.5,1.6-1,1.4.3-.3.2-.6.2-.9.4s-.3.5-.6.7-.5,0-.8.2c-.5.2-.6.8-1,1s-1.2.3-1.8-.2c0-.2.3-.4.4-.5.8-.5,2.1-.9,2.8-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6,24c-.6-1.3,1.3-1.5,1.2-2.6s-.4-1.3.3-1.1.3,1.1.4,1.3c.2.4,1.2-.2,1,.6s-1.2.5-1.5.7-.3,1.6-1.4,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,23.5c1.2-.2,1.2.8.4,1.4s-1.3.8-1.3.1.2-1.4.9-1.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAus);
export default __webpack_public_path__ + "static/media/AUS.92ef47b1ebaca4bcb59fe15a6693d535.svg";
export { ForwardRef as ReactComponent };